// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1805 ? "25f4ac2a" : chunkId) + "." + {"1805":"42c7ab6baf68842f","6698":"e48bc1a5eaff68f1"}[chunkId] + ".js";
};